/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import TableAction from '../../components/TableAction';
import CustomTable from '../../components/common/CustomTable';
import Main from '../../components/HOC/Main';
import { selectSelectedEnquiry, setSelectedEnquiry, toggleCommonDeleteModal } from '../../store/slices/common';
import { deleteEnquiry, fetchEnquiry, selectEnquiryData, setEnquiryData } from '../../store/slices/api/inner/enquirySlice';
import useApiRequest from '../../store/slices/hook/useApiRequest';
import { formateDate } from '../../components/common/FormateDate';


export const EnquiryPage = () => {
  const dispatch = useDispatch();
  const enquiryData = useSelector(selectEnquiryData);
  const selectedEnquiry = useSelector(selectSelectedEnquiry)

  const { handleSubmit: fetchData } = useApiRequest({
    apiAction: fetchEnquiry,
    setValueAction: setEnquiryData,
    isForm: false,
    successMessage: false,
  });


  // delete start
  const openDeleteModal = (data) => {
    dispatch(setSelectedEnquiry(data))
    dispatch(toggleCommonDeleteModal())
  }
  const cancelDeleteModal = () => {
    dispatch(setSelectedEnquiry(null))
    dispatch(toggleCommonDeleteModal())
  }

  const afterAPICall = (res) => {
    fetchData()
    dispatch(setSelectedEnquiry(null))
    dispatch(toggleCommonDeleteModal())
  }

  const { handleSubmit: handleDelete } = useApiRequest({
    apiAction: deleteEnquiry,
    isForm: false,
    afterAPICall,
  });
  // delete end


  const columns = useMemo(() => [

    {
      accessorKey: 'fname',
      cell: info => `${info.row.original.fname} ${info.row.original.lname}`,
      filterFn: 'includesStringSensitive',
      header: "name"
    },

    {
      accessorKey: 'email',
      cell: info => <span>{info.row.original.email}<br /> {info.row.original.phone}</span>,
      filterFn: 'includesStringSensitive',
      header: "contact"
    },

    {
      accessorKey: 'message',
      cell: info => info.getValue(),
      filterFn: 'includesStringSensitive',
    },
    {
      accessorKey: 'enquiry_date',
      cell: info => formateDate(info.getValue()),
      filterFn: 'includesStringSensitive',
      header: "enquiry date"
    },

    {
      id: 'actions',
      cell: info => <TableAction handleDeleteButton={() => { openDeleteModal(info?.row?.original) }} />,
      header: () => <span>Actions</span>,
    },

  ], []);

  useEffect(() => {
    fetchData();
  }, [])

  return (
    <Main crumbs={[{ title: "masters" }, { title: "enquiries" }]} handleDelete={() => { handleDelete({ enquiryId: selectedEnquiry.enquiry_id }) }} handleCandleDelete={cancelDeleteModal}>
      <CustomTable columns={columns} data={enquiryData}
      />
    </Main>
  );
};
